export const FINANCING_COUNTRIES: (string | undefined)[] = ['de', 'at'];

/**
 * Whether the Contracts → Financing tab is reachable for the given permissions object
 * (loaded via PermissionsService for the 'contracts' group, or any object exposing the
 * same `contract`/`loancontract` view flags) AND company country.
 *
 * Financing is reachable only when the company country is 'de' (loans and leasing) or 'at'
 * (leasing only) (country codes are stored lowercase), the user can view Contracts or Loans,
 * and the `loans_as_a_service` feature flag is enabled.
 *
 * Single source of this rule — used by the Financing tab itself and by the Banxware promos
 * that navigate to it. `country` is optional so a missing arg safely yields `false`.
 * Callers supply `loansAsAServiceEnabled` from `FeatureFlagsService.isFeatureEnabled('loans_as_a_service')`.
 */
export function isFinancingReachable(permissions: any, country: string | undefined, loansAsAServiceEnabled: boolean): boolean {
    const hasPermission = !!permissions?.contract?.view || !!permissions?.loancontract?.view;
    return hasPermission && FINANCING_COUNTRIES.includes(country) && loansAsAServiceEnabled;
}
